<template>
	<div>
		<tool-new-level/>
		<div class="tree-table-container">
			<div class="tree-table-header">
				<h3 class="tree-table-header-title">Nombre de la herramienta - configuración</h3>
				<div class="tree-table-header-search">
					<div class="search-input">
						<input
							:style="`color:${$appColors.info}`"
							type="text"
							v-model="search"
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
						/>
						<img
							src="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/magnifying-glass.svg"
							alt="Buscador"
							height="20"
							width="20"
						/>
					</div>
					<div>ícono</div>
				</div>
			</div>
			<tree-tool-table
				:tree-data="treeData"
			></tree-tool-table>
		</div>
		<router-view name="newLevel"></router-view>
		<router-view name="newType"></router-view>
	</div>
</template>
<script>
import toolNewLevel from '@/components/configuration/tools/tool-new-level';
import treeToolTable from '@/components/configuration/tools/tree-tool-table';
import { mapState } from 'vuex';

function created() {
	this.$store.dispatch('tool/toolDetail', this.$route.params.toolCode);
}

function searchRows() {}

function data() {
	return {
		search: '',
	};
}

export default {
	name: 'page-tool-levels',
	components: {
		toolNewLevel,
		treeToolTable,
	},
	computed: {
		...mapState('tool', {
			treeData: state => state.details || [],
		}),
	},
	created,
	data,
	methods: {
		searchRows,
	},
};
</script>
<style lang="scss" scoped>
.tree-table-container {
	background-color: white;

	.tree-table-header {
		align-items: center;
		display: flex;
		padding: 20px 18px;
		justify-content: space-between;
		
		.tree-table-header-title {
			color: color(info);
			font-size: size(xlarge);
			flex: 1 1 60%;
		}

		.tree-table-header-search {
			align-items: center;
			display: flex;
			flex: 1 1 40%;
		}
	}

	.search-input {
		background-color: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
		display: inline-flex;
		height: 37px;
		max-width: 287px;
		margin: 0 10px;
		vertical-align: middle;
		width: 100%;

		input {
			font-size: 14px;
			outline: none;
			padding: 0 5px;
			width: calc(100% - 25px);
		}

		img {
			align-self: center;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/configuration/page-tool-levels.vue